<div class="text-center mt-4">
    <p>You do not have access to edit this quote as it is already converted into policy.</p>
    <p>Please contact the system administration for further information or click on the below button to redirect to main
        website.</p>
    <p class="mt-4"><a href="{{client_website_link}}" class="btn btn-success btn-sm">Back to main website</a></p>
</div>